<template>
  <div>
  <div class="d-flex flx_sic">
    <label class="rate__title mr-1r">{{ $t('views.knowledgeItems.rate.rateTitle') }}</label>
    <span
      class="btn__rate mr-1r"
      :class="{
        'icon__rate--active': buttonActive === 4,
        'icon__rate--disabled': buttonsDisabled
      }"
      @click="rateKnowledgeItem(4)">
      <i
        class="icon-ayudadigital-valoracion-positiva icon__rate icon__rate--positivo"
        :class="{ 'icon__rate__i--active': buttonActive === 4 }"></i>
    </span>
    <span
      class="btn__rate mr-1r"
      :class="{
        'icon__rate--active': buttonActive === 1,
        'icon__rate--disabled': buttonsDisabled
      }"
      @click="checkNegativeComment()">
      <i
        class="icon-ayudadigital-valoracion-negativa icon__rate"
        :class="{ 'icon__rate__i--active': buttonActive === 1 }"></i>
    </span>
  </div>
  <div v-if="valorationNegative" class="mt-2">
    <v-row
      align="center"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-select
          v-model="selectionValNeg"
          :items="motives"
          label="Selecciona un motivo"
          outlined
          :disabled="blockRateActions"
          class="selectNegative"
          @change="() => validValNeg(selectionValNeg)"
        ></v-select>
      </v-col>

    </v-row>
    <v-row :style="{marginTop: '-39px'}"
      v-if="selectionValNeg == 'Otro motivo'"
      align="center"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-textarea
          outlined
          name="input-7-4"
          :disabled="blockRateActions"
          label="Para ayudarnos a mejorar, por favor, detalla por qué no te ha sido útil."
          rows="3"
          v-model="comment"
          @input="() => validValNeg(selectionValNeg)"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row :style="{marginTop: '-39px'}">
      <v-col
        cols="12"
        sm="6"
        align="right"
      >
        <v-btn :disabled="buttonsDisabledValNeg || blockRateActions"
        key="selectionValNeg" color="primary"
          @click="rateKnowledgeItem(1, selectionValNeg)">
          Enviar
        </v-btn>
      </v-col>
    </v-row>
  </div>
</div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    negativeComment: {
      type: Boolean,
      default: true,
    },
    pregunta: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    codigo: {
      type: String,
      required: true,
    },
    canal: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    buttonActive: 0,
    comment: null,
    sendingRating: false,
    buttonsDisabled: false,
    buttonsDisabledValNeg: true,
    valorationNegative: false,
    selectionValNeg: null,
    motives: [],
    blockRateActions: false,
  }),
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },
  created() {
  },
  methods: {
    checkNegativeComment() {
      if (this.negativeComment) {
        this.showValorationNegative();
      } else {
        this.rateKnowledgeItem(1);
      }
    },
    async rateKnowledgeItem(valoracion, motivos) {
      if (valoracion === 4 && !this.blockRateActions) {
        this.valorationNegative = false;
      }
      if (!this.buttonsDisabled) {
        this.buttonActive = valoracion;
        this.buttonsDisabled = true;
        this.buttonsDisabledValNeg = true;

        const { comment } = this;
        const { id: uuid, userid, dni } = this.user;
        this.sendingRating = true;
        const notificationMessageId = await this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.knowledgeItems.messages.sendingRating'),
          icon: 'progress-circular',
        });

        try {
          this.blockRateActions = true;
          const response = await this.$api.getClient('solicitudes').rate({ // eslint-disable-line
            valoracion,
            comment: comment && motivos ? `${motivos} ${comment}` : (motivos || null),
            id: this.id,
            name: this.pregunta,
            uuid,
            username: userid,
            dni,
            codigo: this.codigo,
            canal: this.canal,
          });

          this.sendingRating = false;
          this.currentAction = null;
          this.buttonsDisabled = true;

          this.$store.dispatch('messages/updateMessage', {
            id: notificationMessageId,
            title: this.$t('views.knowledgeItems.messages.ratingSent'),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeout'),
          });
        } catch (ex) {
          console.error('error sending data', ex);
          this.sendingRating = false;
          this.buttonsDisabled = false;
          this.buttonsDisabledValNeg = false;
          this.buttonActive = 0;

          this.$store.dispatch('messages/updateMessage', {
            id: notificationMessageId,
            title: this.$t('views.knowledgeItems.messages.ratingSendingError'),
            icon: 'mdi-times',
            type: 'error',
            timeout: this.$getConst('notifications.timeout'),
          });
        }
      }
    },
    async showValorationNegative() { // eslint-disable-line
      if (!this.blockRateActions) {
        const { id: uuid, userid, dni } = this.user;
        if (this.motives.length === 0) {
          try {
            const response = await this.$api.getClient('solicitudes').getMotives({
              uuid,
              username: userid,
              dni,
            });
            response.data.map((i) => this.motives.push(i.nombre));
          } catch (error) {
            return error;
          }
        }
        this.valorationNegative = !this.valorationNegative;
      }
    },
    validValNeg(selectionValNeg) {
      if (selectionValNeg !== 'Otro motivo') {
        this.buttonsDisabledValNeg = this.selectionValNeg === null;
      } else if (selectionValNeg === 'Otro motivo' && this.comment != null && this.comment.length > 0) {
        this.buttonsDisabledValNeg = this.selectionValNeg === null;
      } else {
        this.buttonsDisabledValNeg = true;
      }
    },
  },
};
</script>

<style lang="scss" coped>
  .flx_sic {
    align-items: center !important;
    flex-wrap: wrap !important;
  }

  .icon__rate--positivo {
    position: absolute;
    top: 0;
  }

  @media (max-width: 960px) {
    .rate__title {
      width: 100%;
      margin-bottom: 1rem;
    }
    .icon__rate--positivo {
      top: -3px;
    }
  }

  .mr-1r {
    margin-right: 1rem !important;
  }

  .btn__rate {
    position: relative;
    font-size: 3rem;
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
    border: 2px solid #27846d;
    border-radius: 50%;
    cursor: pointer;
  }

  .btn__rate:hover {
    background-color: #eaeaea;
  }

  .icon__rate--active {
    background-color: #27846d !important;
    cursor: initial;
  }

  .icon__rate--disabled {
    cursor: initial;
    background-color: #eaeaea;
  }

  .icon__rate__i--active::before {
    color: #ffffff !important;
  }

</style>
